/* r26-home: home page A1-long (25/10). Tabs of « Choisir mon rash »: click, arrow keys, Home and End
   (WAI-ARIA tabs pattern, automatic activation). All panels are already in the HTML. */
(function () {
  function init(list) {
    if (list.dataset.ready) return;
    list.dataset.ready = '1';
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (on && panel) panel.scrollLeft = 0;
      });
      if (focus) tab.focus();
    }
    list.addEventListener('click', function (e) {
      var tab = e.target.closest('[role="tab"]');
      if (tab) select(tab, false);
    });
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var n = null;
      if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = tabs.length - 1;
      if (n === null) return;
      e.preventDefault();
      select(tabs[n], true);
      tabs[n].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }
  function boot(root) {
    (root || document).querySelectorAll('[data-a1-tabs]').forEach(init);
  }
  boot();
  // Theme editor: sections re-rendered on change.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
